export default __webpack_public_path__ + "static/media/up-arrow.583bde46.png";